/**
 * @interface
 */
Foundation.Session.Manager.Delegate = function () {};

/**
 * Return a string identifying this authentication service.
 * @return {string}
 */
Foundation.Session.Manager.Delegate.prototype.sessionManagerID = function () {};

/**
 * Return a promise that is fulfilled once logout is complete.
 * @return {Foundation.Promise!}
 */
Foundation.Session.Manager.Delegate.prototype.logOut = function () {};

/**
 * Handle revalidation. This method must kick off a Foundation.Login.Dialog
 * set to the appropriate screen if the account is not completely set up.
 * (For example, Facebook application has been granted access but Member
 * object is not linked yet.)
 */
Foundation.Session.Manager.Delegate.prototype.revalidateLogin = function () {};

/**
 * Tells the delegate it should begin watching for external session events.
 * For example, it could tell the Facebook app to subscribe to the 
 * auth.authResponseChange event.
 */
Foundation.Session.Manager.Delegate.prototype.observeExternalSessionEvents = function () {};

/**
 * Tells the delegate to stop watching for external session events. For example,
 * it could tell the Facebook app to stop subscribing to the 
 * auth.authResponseChange event.
 */
Foundation.Session.Manager.Delegate.prototype.unobserveExternalSessionEvents = function () {};
